import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center hover:cursor-pointer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    onClick: _cache[0] || (_cache[0] = (...args) => ($setup.open && $setup.open(...args)))
  }, $setup.get_root_props(), { class: "flex justify-center items-center border-2 border-dashed border-gray-300 rounded-lg p-8 hover:cursor-pointer hover:border-blue-400 transition-all" }), [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-lg font-medium text-gray-600 mb-4" }, "Drag and drop files here", -1 /* CACHED */)),
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-gray-400" }, "Or click to select files", -1 /* CACHED */)),
      _createElementVNode("input", _mergeProps({ class: "hidden" }, $setup.get_input_props()), null, 16 /* FULL_PROPS */)
    ])
  ], 16 /* FULL_PROPS */))
}